import { _ as _defineProperty$1 } from '../defineProperty-2d1aa32d.js';
import { _ as _asyncToGenerator$1, r as regenerator$1 } from '../index-e4593f56.js';
import { _ as _slicedToArray$1 } from '../slicedToArray-a6a95674.js';
import React__default, { useState, useMemo, useEffect, useCallback } from 'react';
import { IconCrossLarge } from '@picsart/design-system/foundation/icons/IconCrossLarge';
import { useTranslator } from '@picsart/rc/services/localization';
import { t as typeofD4ZZ_FlZ, i as indexCjs$4 } from '../index-cjs-db83761d.js';
import { useAuthContext } from '@picsart/growth-rc/AuthContext';
import analyticsService from '@picsart/rc/services/analytics';
import { Button, ButtonVariants, ButtonElementTypes, ButtonSizeSM, ButtonSkinAbsoluteBlack, ButtonSkinSecondary, ButtonSkinAbsoluteWhite } from '@picsart/design-system/components/Button';
import IS_BROWSER from '@picsart/rc/isBrowser';
import { u as useCheckoutModalContext } from '../CheckoutModalContext-fa8f6d02.js';
import { getBannerType, fetchSpecialOfferPromo } from '../promoService/index.js';
import useTokenData from '../useTokenData/index.js';
import { T as Timer } from '../Timer-4fc9e29c.js';
import getTimeUntil from '../getTimeUntil/index.js';
import { u as useDataStore } from '../dataStore-426d2a71.js';
import { PROMO_BANNER_ENTRY_POINT, GIFT_VALENTINE_URL, STORAGE_PREFIX } from '../constants/index.js';
import '@picsart/growth-rc/services/auth';
import '@picsart/rc/services/http';
import '@picsart/rc/getDeviceId';
import '@picsart/rc/isDev';
import '@picsart/rc/generateUUID';
import '@picsart/rc/toTitleCase';
import '@picsart/rc/cookie';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { fetchExternalPromoUrl } from '../externalPromoService/index.js';
import { Gradients, AbsolutesWhiteColors, BackgroundColors, SecondaryColors, AbsolutesBlackColors } from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { mediaQuery, BreakPoints } from '../helpers/index.js';

function toPrimitive(t, r) {
  if ("object" != typeofD4ZZ_FlZ._typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeofD4ZZ_FlZ._typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == typeofD4ZZ_FlZ._typeof(i) ? i : i + "";
}
var toPropertyKey_1 = toPropertyKey;
var toPropertyKeyCRgrohXG = {
  toPropertyKey: toPropertyKey_1
};

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKeyCRgrohXG.toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var _classCallCheck_1 = _classCallCheck;
var _createClass_1 = _createClass;
var createClassD1jCN6XC = {
  _classCallCheck: _classCallCheck_1,
  _createClass: _createClass_1
};

var isDev = process.env.NODE_ENV === 'development';
var _default$4 = isDev;
var indexCjs$3 = /*#__PURE__*/Object.defineProperty({
  "default": _default$4
}, '__esModule', {
  value: true
});

/* eslint-disable no-console */
var Logger = /*#__PURE__*/function () {
  function Logger() {
    createClassD1jCN6XC._classCallCheck(this, Logger);
  }
  return createClassD1jCN6XC._createClass(Logger, null, [{
    key: "info",
    value: function info(message) {
      var withConsole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var style = arguments.length > 2 ? arguments[2] : undefined;
      indexCjs$3["default"] && withConsole && console.info(message, style);
    }
  }, {
    key: "success",
    value: function success(message) {
      var withConsole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      indexCjs$3["default"] && withConsole && console.log("%c ".concat(message), 'color:green');
    }
  }, {
    key: "error",
    value: function error(message) {
      var withConsole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      indexCjs$3["default"] && withConsole && console.trace(message);
    }
  }, {
    key: "warn",
    value: function warn(message) {
      var withConsole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      indexCjs$3["default"] && withConsole && console.warn(message);
    }
  }, {
    key: "deprecate",
    value: function deprecate(message) {
      var withConsole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      indexCjs$3["default"] && withConsole && console.warn('DEPRECATION::: ', message);
    }
  }]);
}();
var _default$3 = Logger;
var indexCjs$2 = /*#__PURE__*/Object.defineProperty({
  "default": _default$3
}, '__esModule', {
  value: true
});

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var regeneratorRuntime$1 = {
  exports: {}
};
var _typeof = {
  exports: {}
};
(function (module) {
  function _typeof(o) {
    "@babel/helpers - typeof";

    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
  }
  module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(_typeof);
var _typeofExports = _typeof.exports;
(function (module) {
  var _typeof = _typeofExports["default"];
  function _regeneratorRuntime() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
    module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
      return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o = Object.defineProperty || function (t, e, r) {
        t[e] = r.value;
      },
      i = "function" == typeof Symbol ? Symbol : {},
      a = i.iterator || "@@iterator",
      c = i.asyncIterator || "@@asyncIterator",
      u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
      return Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), t[e];
    }
    try {
      define({}, "");
    } catch (t) {
      define = function define(t, e, r) {
        return t[e] = r;
      };
    }
    function wrap(t, e, r, n) {
      var i = e && e.prototype instanceof Generator ? e : Generator,
        a = Object.create(i.prototype),
        c = new Context(n || []);
      return o(a, "_invoke", {
        value: makeInvokeMethod(t, r, c)
      }), a;
    }
    function tryCatch(t, e, r) {
      try {
        return {
          type: "normal",
          arg: t.call(e, r)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }
    e.wrap = wrap;
    var h = "suspendedStart",
      l = "suspendedYield",
      f = "executing",
      s = "completed",
      y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function () {
      return this;
    });
    var d = Object.getPrototypeOf,
      v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
      ["next", "throw", "return"].forEach(function (e) {
        define(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }
    function AsyncIterator(t, e) {
      function invoke(r, o, i, a) {
        var c = tryCatch(t[r], t, o);
        if ("throw" !== c.type) {
          var u = c.arg,
            h = u.value;
          return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
            invoke("next", t, i, a);
          }, function (t) {
            invoke("throw", t, i, a);
          }) : e.resolve(h).then(function (t) {
            u.value = t, i(u);
          }, function (t) {
            return invoke("throw", t, i, a);
          });
        }
        a(c.arg);
      }
      var r;
      o(this, "_invoke", {
        value: function value(t, n) {
          function callInvokeWithMethodAndArg() {
            return new e(function (e, r) {
              invoke(t, n, e, r);
            });
          }
          return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(e, r, n) {
      var o = h;
      return function (i, a) {
        if (o === f) throw Error("Generator is already running");
        if (o === s) {
          if ("throw" === i) throw a;
          return {
            value: t,
            done: !0
          };
        }
        for (n.method = i, n.arg = a;;) {
          var c = n.delegate;
          if (c) {
            var u = maybeInvokeDelegate(c, n);
            if (u) {
              if (u === y) continue;
              return u;
            }
          }
          if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
            if (o === h) throw o = s, n.arg;
            n.dispatchException(n.arg);
          } else "return" === n.method && n.abrupt("return", n.arg);
          o = f;
          var p = tryCatch(e, r, n);
          if ("normal" === p.type) {
            if (o = n.done ? s : l, p.arg === y) continue;
            return {
              value: p.arg,
              done: n.done
            };
          }
          "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
        }
      };
    }
    function maybeInvokeDelegate(e, r) {
      var n = r.method,
        o = e.iterator[n];
      if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
      var i = tryCatch(o, e.iterator, r.arg);
      if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
      var a = i.arg;
      return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
      var e = {
        tryLoc: t[0]
      };
      1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
      var e = t.completion || {};
      e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
      if (e || "" === e) {
        var r = e[a];
        if (r) return r.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var o = -1,
            i = function next() {
              for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
              return next.value = t, next.done = !0, next;
            };
          return i.next = i;
        }
      }
      throw new TypeError(_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
      var e = "function" == typeof t && t.constructor;
      return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function (t) {
      return {
        __await: t
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
      return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
      void 0 === i && (i = Promise);
      var a = new AsyncIterator(wrap(t, r, n, o), i);
      return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
        return t.done ? t.value : a.next();
      });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
      return this;
    }), define(g, "toString", function () {
      return "[object Generator]";
    }), e.keys = function (t) {
      var e = Object(t),
        r = [];
      for (var n in e) r.push(n);
      return r.reverse(), function next() {
        for (; r.length;) {
          var t = r.pop();
          if (t in e) return next.value = t, next.done = !1, next;
        }
        return next.done = !0, next;
      };
    }, e.values = values, Context.prototype = {
      constructor: Context,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
      },
      stop: function stop() {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var r = this;
        function handle(n, o) {
          return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
        }
        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var i = this.tryEntries[o],
            a = i.completion;
          if ("root" === i.tryLoc) return handle("end");
          if (i.tryLoc <= this.prev) {
            var c = n.call(i, "catchLoc"),
              u = n.call(i, "finallyLoc");
            if (c && u) {
              if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
              if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
            } else if (c) {
              if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            } else {
              if (!u) throw Error("try statement without catch or finally");
              if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t, e) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var o = this.tryEntries[r];
          if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }
        i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
      },
      complete: function complete(t, e) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
      },
      finish: function finish(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
        }
      },
      "catch": function _catch(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.tryLoc === t) {
            var n = r.completion;
            if ("throw" === n.type) {
              var o = n.arg;
              resetTryEntry(r);
            }
            return o;
          }
        }
        throw Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, r, n) {
        return this.delegate = {
          iterator: values(e),
          resultName: r,
          nextLoc: n
        }, "next" === this.method && (this.arg = t), y;
      }
    }, e;
  }
  module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(regeneratorRuntime$1);
var regeneratorRuntimeExports = regeneratorRuntime$1.exports;

// TODO(Babel 8): Remove this file.

var runtime = regeneratorRuntimeExports();
var regenerator = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if ((typeof globalThis === "undefined" ? "undefined" : typeofD4ZZ_FlZ._typeof(globalThis)) === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
var _regeneratorRuntime = /*@__PURE__*/getDefaultExportFromCjs(regenerator);
var _asyncToGenerator_1 = _asyncToGenerator;
var _regeneratorRuntime_1 = _regeneratorRuntime;
var indexDejWf9g2 = {
  _asyncToGenerator: _asyncToGenerator_1,
  _regeneratorRuntime: _regeneratorRuntime_1
};

function _defineProperty(e, r, t) {
  return (r = toPropertyKeyCRgrohXG.toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
var _defineProperty_1 = _defineProperty;
var definePropertyBB_r6qQ2 = {
  _defineProperty: _defineProperty_1
};

var _Storage;
var generateErrorMessage = function generateErrorMessage(e) {
  return e instanceof Error ? e.message : JSON.stringify(e);
};
var isLocalStorageAvailable = function isLocalStorageAvailable() {
  if (indexCjs$4["default"]) {
    try {
      var testKey = '__test__';
      window.localStorage.setItem(testKey, testKey);
      window.localStorage.removeItem(testKey);
      return window.localStorage;
    } catch (e) {
      return fakeStorage;
    }
  }
  return fakeStorage;
};

// new version
var fakeStorage = function () {
  var storage = new Map();
  return {
    getItem: function getItem(key) {
      return storage.get(key);
    },
    setItem: function setItem(key, value) {
      return storage.set(key, value);
    },
    removeItem: function removeItem(key) {
      return storage["delete"](key);
    },
    clear: function clear() {
      return storage = new Map();
    }
  };
}();
var Storage = /*#__PURE__*/function () {
  function Storage() {
    createClassD1jCN6XC._classCallCheck(this, Storage);
    definePropertyBB_r6qQ2._defineProperty(this, "set", /*#__PURE__*/function () {
      var _ref = indexDejWf9g2._asyncToGenerator(/*#__PURE__*/indexDejWf9g2._regeneratorRuntime.mark(function _callee(name, key, data) {
        var storageKey;
        return indexDejWf9g2._regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              storageKey = Storage.generateKey(name, key);
              return _context.abrupt("return", new Promise(function (resolve) {
                setTimeout(function () {
                  try {
                    if (Storage.storage.getItem(storageKey)) {
                      var message = Storage.existMessage.replace('__key__', storageKey);
                      // Logger.info(message, withConsole, Storage.printMessageStyle);
                      return resolve({
                        error: true,
                        message: message
                      });
                    }
                    Storage.storage.setItem(storageKey, Storage.handleData(data));
                    resolve({
                      error: false,
                      message: ''
                    });
                  } catch (e) {
                    return resolve({
                      error: true,
                      message: generateErrorMessage(e)
                    });
                  }
                }, 0);
              }));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
    definePropertyBB_r6qQ2._defineProperty(this, "put", /*#__PURE__*/function () {
      var _ref2 = indexDejWf9g2._asyncToGenerator(/*#__PURE__*/indexDejWf9g2._regeneratorRuntime.mark(function _callee2(name, key, data) {
        var storageKey;
        return indexDejWf9g2._regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              storageKey = Storage.generateKey(name, key);
              return _context2.abrupt("return", new Promise(function (resolve) {
                setTimeout(function () {
                  try {
                    if (!Storage.storage.getItem(storageKey)) {
                      var message = Storage.notFoundMessage.replace('__key__', storageKey);
                      // Logger.info(message, withConsole, Storage.printMessageStyle);
                      return resolve({
                        error: true,
                        message: message
                      });
                    }
                    Storage.storage.setItem(storageKey, Storage.handleData(data));
                    resolve({
                      error: false,
                      message: ''
                    });
                  } catch (e) {
                    return resolve({
                      error: true,
                      message: generateErrorMessage(e)
                    });
                  }
                }, 0);
              }));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }());
    definePropertyBB_r6qQ2._defineProperty(this, "get", /*#__PURE__*/function () {
      var _ref3 = indexDejWf9g2._asyncToGenerator(/*#__PURE__*/indexDejWf9g2._regeneratorRuntime.mark(function _callee3(name, key) {
        var storageKey;
        return indexDejWf9g2._regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              storageKey = Storage.generateKey(name, key);
              return _context3.abrupt("return", new Promise(function (resolve) {
                setTimeout(function () {
                  var returnValue;
                  try {
                    returnValue = JSON.parse(Storage.storage.getItem(storageKey));
                  } catch (e) {
                    // Logger.error(e as string, withConsole);
                  }
                  if (returnValue) {
                    return resolve({
                      error: false,
                      message: '',
                      date: returnValue
                    });
                  }
                  var message = Storage.notFoundMessage.replace('__key__', storageKey);
                  // Logger.info(message, withConsole, Storage.printMessageStyle);
                  return resolve({
                    error: true,
                    message: message,
                    date: null
                  });
                }, 0);
              }));
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x7, _x8) {
        return _ref3.apply(this, arguments);
      };
    }());
    definePropertyBB_r6qQ2._defineProperty(this, "remove", /*#__PURE__*/function () {
      var _ref4 = indexDejWf9g2._asyncToGenerator(/*#__PURE__*/indexDejWf9g2._regeneratorRuntime.mark(function _callee4(name, key) {
        var storageKey;
        return indexDejWf9g2._regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              storageKey = Storage.generateKey(name, key);
              return _context4.abrupt("return", new Promise(function (resolve, reject) {
                setTimeout(function () {
                  try {
                    Storage.storage.removeItem(storageKey);
                    return resolve({
                      error: false,
                      message: ''
                    });
                  } catch (e) {
                    return reject({
                      error: true,
                      message: e instanceof Error ? e.message : JSON.stringify(e)
                    });
                  }
                }, 0);
              }));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x9, _x10) {
        return _ref4.apply(this, arguments);
      };
    }());
    definePropertyBB_r6qQ2._defineProperty(this, "clear", /*#__PURE__*/indexDejWf9g2._asyncToGenerator(/*#__PURE__*/indexDejWf9g2._regeneratorRuntime.mark(function _callee5() {
      return indexDejWf9g2._regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", new Promise(function (resolve) {
              setTimeout(function () {
                try {
                  Storage.storage.clear();
                  return resolve({
                    error: false,
                    message: ''
                  });
                } catch (e) {
                  return resolve({
                    error: true,
                    message: e instanceof Error ? e.message : JSON.stringify(e)
                  });
                }
              }, 0);
            }));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })));
    definePropertyBB_r6qQ2._defineProperty(this, "setSync", function (name, key, data) {
      var onError = arguments.length > 4 ? arguments[4] : undefined;
      var storageKey = Storage.generateKey(name, key);
      if (Storage.storage.getItem(storageKey)) {
        // const message = Storage.existMessage.replace('__key__', storageKey);
        // Logger.info(message, withConsole, Storage.printMessageStyle);
        return;
      }
      try {
        Storage.storage.setItem(storageKey, Storage.handleData(data));
      } catch (e) {
        if (typeof onError === 'function') onError(e);
      }
    });
    definePropertyBB_r6qQ2._defineProperty(this, "putSync", function (name, key, data, isAnalytic) {
      var onError = arguments.length > 5 ? arguments[5] : undefined;
      var storageKey = Storage.generateKey(name, key);
      // if (!Storage.storage.getItem(storageKey)) {
      //   // const message = Storage.notFoundMessage.replace('__key__', storageKey);
      //   // Logger.info(message, withConsole, Storage.printMessageStyle);
      // }
      // @ts-ignore
      var realData = isAnalytic ? data === null || data === void 0 ? void 0 : data.filter(function (item, i, self) {
        return self.findIndex(function (v2) {
          var _v2$event, _item$event;
          return (v2 === null || v2 === void 0 || (_v2$event = v2.event) === null || _v2$event === void 0 || (_v2$event = _v2$event.data) === null || _v2$event === void 0 ? void 0 : _v2$event.filterId) === (item === null || item === void 0 || (_item$event = item.event) === null || _item$event === void 0 || (_item$event = _item$event.data) === null || _item$event === void 0 ? void 0 : _item$event.filterId);
        }) === i;
      }) : data;
      try {
        Storage.storage.setItem(storageKey, Storage.handleData(realData));
      } catch (e) {
        if (typeof onError === 'function') onError(e);
      }
    });
    definePropertyBB_r6qQ2._defineProperty(this, "getSync", function (name, key) {
      var onError = arguments.length > 3 ? arguments[3] : undefined;
      try {
        var storageKey = Storage.generateKey(name, key);
        var returnValue = Storage.storage.getItem(storageKey);
        if (!returnValue) {
          // const message = Storage.notFoundMessage.replace('__key__', storageKey);
          // Logger.info(message, withConsole, Storage.printMessageStyle);
          return;
        }
        return JSON.parse(returnValue);
      } catch (e) {
        if (typeof onError === 'function') onError(e);
      }
    });
    definePropertyBB_r6qQ2._defineProperty(this, "removeSync", function (name, key, onError) {
      try {
        var storageKey = Storage.generateKey(name, key);
        Storage.storage.removeItem(storageKey);
      } catch (e) {
        if (typeof onError === 'function') onError(e);
      }
    });
    definePropertyBB_r6qQ2._defineProperty(this, "clearSync", function (onError) {
      try {
        Storage.storage.clear();
      } catch (e) {
        if (typeof onError === 'function') onError(e);
      }
    });
    definePropertyBB_r6qQ2._defineProperty(this, "removeItem", function (name, key, onError) {
      try {
        Storage.storage.removeItem(key);
      } catch (e) {
        if (typeof onError === 'function') onError(e);
      }
    });
  }
  return createClassD1jCN6XC._createClass(Storage, null, [{
    key: "handleData",
    value: function handleData(data) {
      return JSON.stringify(data, Storage.replacer);
    }
  }]);
}();
_Storage = Storage;
definePropertyBB_r6qQ2._defineProperty(Storage, "existMessage", 'there already exists data in storage with this key: %c__key__');
definePropertyBB_r6qQ2._defineProperty(Storage, "notFoundMessage", 'there is not found any existing data in storage with this key: %c__key__');
definePropertyBB_r6qQ2._defineProperty(Storage, "printMessageStyle", 'font-weight: bold; font-size: 12px');
definePropertyBB_r6qQ2._defineProperty(Storage, "notAllowedTypes", ['function', 'symbol', 'bigint']);
definePropertyBB_r6qQ2._defineProperty(Storage, "storage", indexCjs$4["default"] && isLocalStorageAvailable() || fakeStorage);
definePropertyBB_r6qQ2._defineProperty(Storage, "generateKey", function (name, key) {
  return "".concat(name).concat(key);
});
definePropertyBB_r6qQ2._defineProperty(Storage, "replacer", function (key, value) {
  var typeOfValue = typeofD4ZZ_FlZ._typeof(value);
  if (_Storage.notAllowedTypes.includes(typeOfValue)) ;
  return value;
});
var storageApi = new Storage();
var _default$2 = storageApi;
var indexCjs$1 = /*#__PURE__*/Object.defineProperty({
  "default": _default$2
}, '__esModule', {
  value: true
});

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) ;else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
var _slicedToArray_1 = _slicedToArray;
var slicedToArrayDiwuscFk = {
  _slicedToArray: _slicedToArray_1
};

var useForceUpdate = function useForceUpdate() {
  var _useState = React__default.useState({}),
    _useState2 = slicedToArrayDiwuscFk._slicedToArray(_useState, 2),
    update = _useState2[1];
  return React__default.useCallback(function () {
    return update({});
  }, []);
};
var _default$1 = useForceUpdate;
var indexCjs = /*#__PURE__*/Object.defineProperty({
  "default": _default$1
}, '__esModule', {
  value: true
});

var FORCE_UPDATE_EVENT_NAME = 'forceUpdate';
function useLocalStorage(prefix, key, initialValue) {
  var withConsole = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var forceUpdateEventRef = React__default.useRef();
  if (!forceUpdateEventRef.current) {
    forceUpdateEventRef.current = new CustomEvent(FORCE_UPDATE_EVENT_NAME, {
      detail: {
        key: key
      }
    });
  }
  var forceUpdate = indexCjs["default"]();
  React__default.useEffect(function () {
    var parallelUpdateHandler = function parallelUpdateHandler(event) {
      if (event.detail.key !== key) return;
      forceUpdate();
    };
    document.addEventListener(FORCE_UPDATE_EVENT_NAME, parallelUpdateHandler);
    return function () {
      document.removeEventListener(FORCE_UPDATE_EVENT_NAME, parallelUpdateHandler);
    };
  }, [forceUpdate, key, prefix]);
  React__default.useMemo(function () {
    var result = indexCjs$1["default"].getSync(prefix, key);
    if (result === undefined || result === null) {
      indexCjs$1["default"].putSync(prefix, key, initialValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefix, key]);
  var updateValue = React__default.useCallback(function (value) {
    try {
      var _storageApi$getSync;
      var result = typeof value === 'function' ? value((_storageApi$getSync = indexCjs$1["default"].getSync(prefix, key)) !== null && _storageApi$getSync !== void 0 ? _storageApi$getSync : initialValue) : value;
      indexCjs$1["default"].putSync(prefix, key, result);
      document.dispatchEvent(forceUpdateEventRef.current);
    } catch (e) {
      indexCjs$2["default"].error(e, withConsole);
    }
  }, [prefix, key, initialValue, withConsole]);
  return [indexCjs$1["default"].getSync(prefix, key), updateValue];
}
var _default = useLocalStorage;

var typeStyles = {
  purple: {
    background: Gradients.pro,
    color: AbsolutesWhiteColors.base["default"],
    separatorColor: AbsolutesWhiteColors.base["default"],
    crossIconColor: AbsolutesWhiteColors.base["default"]
  },
  light: {
    background: BackgroundColors.tint1,
    color: SecondaryColors.base["default"],
    separatorColor: BackgroundColors.tint3,
    crossIconColor: SecondaryColors.base["default"]
  },
  yellow: {
    background: 'linear-gradient(315deg, #FFD15A 14.64%, #FFB017 85.36%)',
    color: AbsolutesBlackColors.base["default"],
    separatorColor: AbsolutesBlackColors.base["default"],
    crossIconColor: AbsolutesBlackColors.base["default"]
  },
  pink: {
    background: 'linear-gradient(315deg, #F44097 25%, #FC67FA 75%)',
    color: AbsolutesWhiteColors.base["default"],
    separatorColor: AbsolutesWhiteColors.base["default"],
    crossIconColor: AbsolutesWhiteColors.base["default"]
  },
  green: {
    background: '#89E219',
    color: AbsolutesBlackColors.base["default"],
    crossIconColor: AbsolutesBlackColors.base["default"]
  }
};
var useStyles = createUseStyles({
  root: _defineProperty$1({
    padding: [Spacings.s4, Spacings.s16],
    background: function background(_ref) {
      var type = _ref.type;
      return typeStyles[type].background;
    },
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    border: 'none',
    width: '100%'
  }, mediaQuery(BreakPoints.Small), {
    padding: [Spacings.s6, Spacings.s8]
  }),
  disappearingHeart: _defineProperty$1({}, mediaQuery(BreakPoints.Small), {
    display: 'none'
  }),
  additionalBlock: _defineProperty$1({}, mediaQuery(BreakPoints.Small), {
    display: 'none'
  }),
  timerText: _defineProperty$1({}, mediaQuery(BreakPoints.Small), {
    display: 'none'
  }),
  content: _defineProperty$1({
    color: function color(_ref2) {
      var type = _ref2.type;
      return typeStyles[type].color;
    },
    fontWeight: FontWeights.semibold,
    justifyContent: 'center',
    fontSize: FontSizes.s14,
    gap: Spacings.s16,
    alignItems: 'center',
    display: 'flex'
  }, mediaQuery(BreakPoints.Small), {
    gap: Spacings.s8
  }),
  offerButton: _defineProperty$1({}, mediaQuery(BreakPoints.Small), {
    display: 'none'
  }),
  textDesktop: _defineProperty$1({}, mediaQuery(BreakPoints.Small), {
    display: 'none'
  }),
  textMobile: _defineProperty$1({
    display: 'none'
  }, mediaQuery(BreakPoints.Small), {
    display: 'block'
  }),
  timerWrapper: {
    gap: Spacings.s8,
    alignItems: 'center',
    display: 'flex'
  },
  separator: _defineProperty$1({
    backgroundColor: function backgroundColor(_ref3) {
      var type = _ref3.type;
      return typeStyles[type].separatorColor;
    },
    height: Spacings.s24,
    width: Spacings.s2,
    borderRadius: CornerRadius.r2
  }, mediaQuery(BreakPoints.Small), {
    display: 'none'
  }),
  closeIcon: {
    color: function color(_ref4) {
      var type = _ref4.type;
      return typeStyles[type].crossIconColor;
    }
  }
}, {
  name: 'pa-monetization-promo-top-banner'
});

var valentineAssets = ['https://pastatic.picsart.com/cms-pastatic/a2e843da-0696-4d66-bc71-bae974c29e3d.png', 'https://pastatic.picsart.com/cms-pastatic/7a5a5edf-f529-4f77-ad8a-c4cbdfea2a3e.png'];
var duolingoAssets = ['https://cdn-cms-uploads.picsart.com/cms-uploads/ae25ef75-5994-4ad4-a388-1e90c53fd371.png', 'https://cdn-cms-uploads.picsart.com/cms-uploads/034b9d9c-b682-45fc-8f72-de07f85cedd9.svg'];

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty$1(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var buttonSkins = {
  yellow: ButtonSkinAbsoluteBlack,
  light: ButtonSkinSecondary,
  purple: ButtonSkinAbsoluteWhite,
  pink: ButtonSkinAbsoluteWhite,
  green: ButtonSkinAbsoluteBlack
};
var timerSkins = {
  yellow: 'black',
  light: 'light',
  purple: 'white',
  pink: 'white'
};
var actionButton = 'top_banner';
var PromoTopBanner = function PromoTopBanner(_ref) {
  var _offerPromo$special_o, _offerPromo$special_o2, _offerPromo$special_o3;
  var checkoutGtmData = _ref.checkoutGtmData,
    onButtonClick = _ref.onButtonClick,
    handleBannerClose = _ref.handleBannerClose;
  var _useCheckoutModalCont = useCheckoutModalContext(),
    setIsOpen = _useCheckoutModalCont.setIsOpen,
    userSubscriptionState = _useCheckoutModalCont.userSubscriptionState,
    userSubscription = _useCheckoutModalCont.userSubscription;
  var _useState = useState(),
    _useState2 = _slicedToArray$1(_useState, 2),
    offerPromo = _useState2[0],
    setOfferPromo = _useState2[1];
  var nextDay = useMemo(function () {
    return Date.now() + 24 * 60 * 60 * 1000;
  }, []);
  var currentTime = useMemo(function () {
    return Date.now();
  }, []);
  var _useLocalStorage = _default(STORAGE_PREFIX, 'banner_close_count', {
      name: '',
      count: 0,
      restartTime: nextDay
    }),
    _useLocalStorage2 = _slicedToArray$1(_useLocalStorage, 2),
    closeInfo = _useLocalStorage2[0],
    setCloseInfo = _useLocalStorage2[1];
  var _useTokenData = useTokenData(),
    getAccessToken = _useTokenData.getAccessToken;
  var _useAuthContext = useAuthContext(),
    user = _useAuthContext.user;
  var _useDataStore = useDataStore(),
    _useDataStore2 = _slicedToArray$1(_useDataStore, 1),
    userOrder = _useDataStore2[0].userOrder;
  var translate = useTranslator();
  var isRemainingTimeMoreThanMonth = useMemo(function () {
    var _getTimeUntil;
    return parseInt((_getTimeUntil = getTimeUntil(userSubscription === null || userSubscription === void 0 ? void 0 : userSubscription.expire_date)) === null || _getTimeUntil === void 0 ? void 0 : _getTimeUntil.days, 10) >= 30;
  }, [userSubscription === null || userSubscription === void 0 ? void 0 : userSubscription.expire_date]);
  var isValentine = (offerPromo === null || offerPromo === void 0 || (_offerPromo$special_o = offerPromo.special_offer_data) === null || _offerPromo$special_o === void 0 ? void 0 : _offerPromo$special_o.name) === 'valentine';
  var isWinback = (offerPromo === null || offerPromo === void 0 || (_offerPromo$special_o2 = offerPromo.special_offer_data) === null || _offerPromo$special_o2 === void 0 ? void 0 : _offerPromo$special_o2.name) === 'Winback50';
  var isDuolingo = (offerPromo === null || offerPromo === void 0 || (_offerPromo$special_o3 = offerPromo.special_offer_data) === null || _offerPromo$special_o3 === void 0 ? void 0 : _offerPromo$special_o3.name) === 'duolingo';
  var bannerType = useMemo(function () {
    var _userOrder$additional;
    return getBannerType({
      lastRenewalPaymentStatus: userOrder === null || userOrder === void 0 || (_userOrder$additional = userOrder.additionalInfo) === null || _userOrder$additional === void 0 ? void 0 : _userOrder$additional.lastRenewalPaymentStatus,
      offerPromo: offerPromo,
      expire_date: userSubscription === null || userSubscription === void 0 ? void 0 : userSubscription.expire_date
    });
  }, [userSubscription === null || userSubscription === void 0 ? void 0 : userSubscription.expire_date, offerPromo, userOrder]);
  var classes = useStyles({
    type: bannerType
  });
  var expireDate = useMemo(function () {
    return isWinback ? userSubscription === null || userSubscription === void 0 ? void 0 : userSubscription.expire_date : offerPromo === null || offerPromo === void 0 ? void 0 : offerPromo.expire_date;
  }, [isWinback, offerPromo, userSubscription]);
  var _useMemo = useMemo(function () {
      return offerPromo || {
        discount_percent: 0
      };
    }, [offerPromo]),
    discountPercent = _useMemo.discount_percent;
  var description = useMemo(function () {
    var _offerPromo$descripti;
    if (isWinback) {
      return translate('LIMITED-TIME OFFER: Restart your subscription and enjoy {{discount}}% off!', {
        discount: discountPercent
      });
    }
    return translate((_offerPromo$descripti = offerPromo === null || offerPromo === void 0 ? void 0 : offerPromo.description) !== null && _offerPromo$descripti !== void 0 ? _offerPromo$descripti : '');
  }, [isWinback, translate, discountPercent, offerPromo]);
  var buttonCopy = useMemo(function () {
    if (isValentine) {
      return translate('Gift Picsart Pro');
    }
    if (isDuolingo) {
      return translate('Try Duolingo for free');
    }
    return discountPercent ? translate('Save {{discount}}% off Pro', {
      discount: discountPercent
    }) : null;
  }, [translate, discountPercent, isDuolingo, isValentine]);
  var showTimer = useMemo(function () {
    if (!expireDate || !getTimeUntil(expireDate)) return false;
    if (isWinback) {
      return !isRemainingTimeMoreThanMonth;
    }
    if (isValentine || isDuolingo) {
      return false;
    }
    return true;
  }, [isValentine, isRemainingTimeMoreThanMonth, expireDate, isWinback, isDuolingo]);
  var assets = useMemo(function () {
    if (isDuolingo) {
      return duolingoAssets;
    }
    if (isValentine) {
      return valentineAssets;
    }
    return null;
  }, [isDuolingo, isValentine]);
  var shortDescription = useMemo(function () {
    var _offerPromo$short_des;
    if (isWinback) {
      if (!showTimer) {
        return translate('Restart your subscription and enjoy {{discount}}% off!', {
          discount: discountPercent
        });
      }
    }
    return translate((_offerPromo$short_des = offerPromo === null || offerPromo === void 0 ? void 0 : offerPromo.short_description) !== null && _offerPromo$short_des !== void 0 ? _offerPromo$short_des : '');
  }, [offerPromo, translate, showTimer, isWinback, discountPercent]);
  var timerText = useMemo(function () {
    if (isWinback) {
      return translate('until premium access ends');
    }
    return translate('until offer ends');
  }, [translate, isWinback]);
  useEffect(function () {
    _asyncToGenerator$1(/*#__PURE__*/regenerator$1.mark(function _callee() {
      var accessToken, _yield$fetchSpecialOf, response, status;
      return regenerator$1.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            accessToken = getAccessToken();
            _context.next = 4;
            return fetchSpecialOfferPromo({
              touchpoint: actionButton
            }, accessToken);
          case 4:
            _yield$fetchSpecialOf = _context.sent;
            response = _yield$fetchSpecialOf.response;
            status = _yield$fetchSpecialOf.status;
            if (status === 'success' && response) {
              setOfferPromo(response);
            } else {
              setOfferPromo(undefined);
            }
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            setOfferPromo(undefined);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10]]);
    }))();
  }, [getAccessToken, user === null || user === void 0 ? void 0 : user.id]);
  useEffect(function () {
    var _offerPromo$special_o4;
    if (offerPromo !== null && offerPromo !== void 0 && (_offerPromo$special_o4 = offerPromo.special_offer_data) !== null && _offerPromo$special_o4 !== void 0 && _offerPromo$special_o4.banner_show_count && (closeInfo.name !== offerPromo.special_offer_data.name || closeInfo.restartTime <= currentTime)) {
      setCloseInfo({
        name: offerPromo.special_offer_data.name,
        count: 0,
        restartTime: nextDay
      });
    }
  }, [offerPromo, closeInfo.name, closeInfo.restartTime, nextDay, setCloseInfo, currentTime]);
  var openCheckoutModal = useCallback(function () {
    var _offerPromo$tier_ids;
    setIsOpen(true, {
      forceTier: (offerPromo === null || offerPromo === void 0 || (_offerPromo$tier_ids = offerPromo.tier_ids) === null || _offerPromo$tier_ids === void 0 ? void 0 : _offerPromo$tier_ids.length) === 1 ? offerPromo.tier_ids[0] : undefined,
      entryPoint: PROMO_BANNER_ENTRY_POINT,
      isUpgradeDisabled: isWinback,
      isTeamDisabled: true,
      isProAllowed: true,
      gtmData: _objectSpread({
        action_button: actionButton
      }, checkoutGtmData)
    });
  }, [checkoutGtmData, setIsOpen, offerPromo === null || offerPromo === void 0 ? void 0 : offerPromo.tier_ids, isWinback]);
  var handleClick = useCallback(/*#__PURE__*/_asyncToGenerator$1(/*#__PURE__*/regenerator$1.mark(function _callee2() {
    var windowRef, _yield$fetchExternalP, response, status;
    return regenerator$1.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          analyticsService.sendEvent('monetization_button_click', {
            screen_type: 'campaign_promo_banner',
            promo_id: offerPromo === null || offerPromo === void 0 ? void 0 : offerPromo.code,
            button_type: 'main'
          });
          if (!onButtonClick) {
            _context2.next = 5;
            break;
          }
          onButtonClick();
          _context2.next = 20;
          break;
        case 5:
          if (!isValentine) {
            _context2.next = 9;
            break;
          }
          IS_BROWSER && window.open(GIFT_VALENTINE_URL, '_blank');
          _context2.next = 20;
          break;
        case 9:
          if (!isDuolingo) {
            _context2.next = 19;
            break;
          }
          windowRef = window.open(); // open window on click to avoid popup blocker
          _context2.next = 13;
          return fetchExternalPromoUrl({
            name: 'Duolingo'
          });
        case 13:
          _yield$fetchExternalP = _context2.sent;
          response = _yield$fetchExternalP.response;
          status = _yield$fetchExternalP.status;
          if (status === 'success' && response && windowRef) {
            windowRef.location.href = response.fullUrl;
          }
          _context2.next = 20;
          break;
        case 19:
          openCheckoutModal();
        case 20:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [onButtonClick, openCheckoutModal, isValentine, isDuolingo, offerPromo === null || offerPromo === void 0 ? void 0 : offerPromo.code]);
  var handleClose = useCallback(function (e) {
    var _offerPromo$special_o5;
    e.stopPropagation();
    analyticsService.sendEvent('monetization_button_click', {
      screen_type: 'campaign_promo_banner',
      promo_id: offerPromo === null || offerPromo === void 0 ? void 0 : offerPromo.code,
      button_type: 'close'
    });
    if (offerPromo !== null && offerPromo !== void 0 && (_offerPromo$special_o5 = offerPromo.special_offer_data) !== null && _offerPromo$special_o5 !== void 0 && _offerPromo$special_o5.banner_show_count) {
      setCloseInfo(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          count: prev.count + 1
        });
      });
    }
    handleBannerClose === null || handleBannerClose === void 0 || handleBannerClose();
  }, [offerPromo, handleBannerClose, setCloseInfo]);
  var isClosingCountRiched = useMemo(function () {
    var _offerPromo$special_o6, _offerPromo$special_o7, _offerPromo$special_o8;
    return (offerPromo === null || offerPromo === void 0 || (_offerPromo$special_o6 = offerPromo.special_offer_data) === null || _offerPromo$special_o6 === void 0 ? void 0 : _offerPromo$special_o6.name) === closeInfo.name && !!(offerPromo !== null && offerPromo !== void 0 && (_offerPromo$special_o7 = offerPromo.special_offer_data) !== null && _offerPromo$special_o7 !== void 0 && _offerPromo$special_o7.banner_show_count) && (offerPromo === null || offerPromo === void 0 || (_offerPromo$special_o8 = offerPromo.special_offer_data) === null || _offerPromo$special_o8 === void 0 ? void 0 : _offerPromo$special_o8.banner_show_count) <= closeInfo.count;
  }, [closeInfo, offerPromo]);
  // don't render if promo is not available
  if (!offerPromo || userSubscriptionState === 'pending') return null;
  if (isClosingCountRiched) return null;
  if (isWinback) {
    if ((userSubscription === null || userSubscription === void 0 ? void 0 : userSubscription.status) === 'SUBSCRIPTION_RESTARTED') return null;
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    jsxs("div", {
      "data-testid": "banner-content",
      className: classes.root,
      onClick: handleClick,
      role: "button",
      children: [/*#__PURE__*/jsx("div", {
        className: classes.additionalBlock
      }), /*#__PURE__*/jsxs("div", {
        className: classes.content,
        children: [(assets === null || assets === void 0 ? void 0 : assets[0]) && /*#__PURE__*/jsx("img", {
          src: assets[0],
          height: 24,
          className: classes.disappearingHeart
        }), showTimer && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsxs("div", {
            className: classes.timerWrapper,
            "data-testid": "timer",
            children: [/*#__PURE__*/jsx(Timer, {
              endDate: expireDate,
              skin: timerSkins[bannerType]
            }), /*#__PURE__*/jsx("span", {
              className: classes.timerText,
              children: timerText
            })]
          }), /*#__PURE__*/jsx("div", {
            className: classes.separator
          })]
        }), /*#__PURE__*/jsx("div", {
          className: classes.textDesktop,
          children: description
        }), /*#__PURE__*/jsx("div", {
          className: classes.textMobile,
          children: shortDescription && translate(shortDescription, {
            discount: discountPercent
          })
        }), buttonCopy && /*#__PURE__*/jsx(Button, {
          variant: ButtonVariants.Outline,
          tag: ButtonElementTypes.Button,
          className: classes.offerButton,
          skin: buttonSkins[bannerType],
          size: ButtonSizeSM,
          children: buttonCopy
        }), (assets === null || assets === void 0 ? void 0 : assets[1]) && /*#__PURE__*/jsx("img", {
          src: assets[1],
          height: 24
        })]
      }), handleBannerClose ? /*#__PURE__*/jsx(Button, {
        size: ButtonSizeSM,
        centerIcon: IconCrossLarge,
        variant: ButtonVariants.Text,
        className: classes.closeIcon,
        onClick: handleClose,
        "data-testid": "close-button"
      }) : /*#__PURE__*/jsx("div", {})]
    })
  );
};

export { PromoTopBanner as default };
//# sourceMappingURL=index.js.map
